import { loadStripe, type Stripe } from '@stripe/stripe-js';

const BASE = import.meta.env.VITE_SALE_API_URL ?? 'http://localhost:8003';

export type ActiveProvider = 'stripe' | 'stancer';

export interface PublicCheckoutConfig {
  active_provider: ActiveProvider;
  mode: 'test' | 'live';
  // Stripe-only (present when active_provider === 'stripe'):
  stripe_publishable_key?: string;
  stripe_mode?: string;                             // legacy alias for `mode`, still emitted by backend
  // Stancer-only (present when active_provider === 'stancer'):
  stancer_public_key?: string;
}

export async function getPublicCheckoutConfig(restaurantUuid: string): Promise<PublicCheckoutConfig> {
  const response = await fetch(`${BASE}/sale/order/order/config/public/${restaurantUuid}/`);
  if (!response.ok) throw new Error(`public config fetch failed: ${response.status}`);
  return (await response.json()) as PublicCheckoutConfig;
}

const cache = new Map<string, Promise<Stripe | null>>();

export function getStripePromise(restaurantUuid: string): Promise<Stripe | null> {
  let promise = cache.get(restaurantUuid);
  if (!promise) {
    promise = (async () => {
      const cfg = await getPublicCheckoutConfig(restaurantUuid);
      if (cfg.active_provider === 'stancer' || !cfg.stripe_publishable_key) {
        throw new Error('NOT_STRIPE');
      }
      // En mode test (pk_test_…) Stripe.js pose un cadre « developer tools » fixe
      // 123×72 en bas à droite (z-index 99999) qui recouvre « Suivant » sur
      // mobile. Les clés live ne l'affichent jamais.
      return loadStripe(cfg.stripe_publishable_key, {
        developerTools: { assistant: { enabled: false } },
      });
    })();
    cache.set(restaurantUuid, promise);
  }
  return promise;
}

export function _resetStripeClientForTests() {
  cache.clear();
}
